<ng-container *transloco="let t; read:'formElements'">
	<ng-template #input>
		<input
			#rangeInput
			class="form-control date-range-picker"
			name="dateRangePicker"
			autocomplete="off"
			[id]="id"
			[ngClass]="{
					invalid: control.touched && control.errors,
					valueSet: clearable && control.touched && valueSet
				}"
			[placeholder]="placeholder ? placeholder : t('fieldText.fromDate') + '   |   ' + t('fieldText.toDate')"
			[value]="dateString"
			ngbDatepicker
			[displayMonths]="2"
			[startDate]="startDate"
			[maxDate]="maxDate"
			[minDate]="minDate"
			(click)="dateRangePickerInput.toggle(); control.markAsTouched()"
			(keydown)="$event.preventDefault()"
			[autoClose]="'outside'"
			[showWeekNumbers]="true"
			[dayTemplate]="dayTemplate"
			#dateRangePickerInput="ngbDatepicker">

		<ng-template #dayTemplate
					 let-date="date"
					 let-currentMonth="currentMonth"
					 let-selected="selected"
					 let-disabled="disabled"
					 let-focused="focused"
		>
			<div class="btn-light custom-day has-overlay"
				 *ngIf="hasOverlay(date)"
				 [class.range]="isInRange(date)"
				 [class.faded]="isHovered(date) || isInside(date)"
				 [class.active]="selected"
				 [class.notCurrent]="date.month != currentMonth"
				 [class.hidden]="date.month !== currentMonth"
				 [class.text-muted]="disabled"
				 (click)="onDateSelection(date)"
				 (mouseenter)="hoveredDate = date"
				 (mouseleave)="hoveredDate = null"
				 [ngbTooltip]="calOverlay['year_'+date.year]['month_'+date.month]['day_'+date.day].entries.length + ' ' + t('entries')"
			>
				{{ date.day }}
				<span *ngIf="shouldShowMarker(date, 0)"></span>
				<span *ngIf="shouldShowMarker(date, 1)"></span>
				<span *ngIf="shouldShowMarker(date, 5)"></span>
				<span *ngIf="shouldShowMarker(date, 10)"></span>
				<span *ngIf="shouldShowMarker(date, 20)"></span>
			</div>
			<div class="btn-light custom-day"
				 *ngIf="!hasOverlay(date)"
				 [class.range]="isInRange(date)"
				 [class.faded]="isHovered(date) || isInside(date)"
				 [class.active]="selected"
				 [class.notCurrent]="date.month != currentMonth"
				 [class.hidden]="date.month !== currentMonth"
				 [class.text-muted]="disabled"
				 (click)="onDateSelection(date)"
				 (mouseenter)="hoveredDate = date"
				 (mouseleave)="hoveredDate = null"
			>
				{{ date.day }}
			</div>
		</ng-template>

		<span class="clear-filter-icon"
			  *ngIf="clearable && control.touched && control.controls.start.value"
			  (click)="clear()">
			<i class="fa-solid fa-square-x"></i>
		</span>

		<span class="chevron-wrapper"
			  *ngIf="template === ControlTemplate.inlineFromTo"
			  (click)="dateRangePickerInput.open()"
			  [class.rotate]="dateRangePickerInput.isOpen()"
		>
			<i class="fas fa-chevron-down"></i>
		</span>

		<div *ngIf="control.touched && control.errors" class="error-indicator">
			<shared-icon-sprite svgId="general-t-warning" width="20" height="20"></shared-icon-sprite>
		</div>
	</ng-template>

	<ng-template #inlineFromTo>
		<div class="input-group">
			<ng-container *ngTemplateOutlet="input"></ng-container>
		</div>
	</ng-template>

	<ng-template #errors>
		<ng-container *ngIf="control.touched">
			<div [ngClass]="{'control-errors-vertical': template === ControlTemplate.vertical}"
				 class="control-errors col-12" *ngFor="let error of control.errors | keyvalue">
				<span class="error">{{ t('generic.' + error.key) }}</span>
			</div>
		</ng-container>
	</ng-template>

	<ng-container>
		<div [ngSwitch]="template" class="form-control-container">
			<ng-container *ngSwitchCase="ControlTemplate.inlineFromTo">
				<ng-container *ngTemplateOutlet="inlineFromTo"></ng-container>
				<ng-container *ngTemplateOutlet="errors"></ng-container>
			</ng-container>
		</div>
	</ng-container>
</ng-container>


